import { Tooltip, Typography } from "antd";
import React from "react";
import { BiEditAlt } from "react-icons/bi";
import styles from "../styles/Client.module.css";

const LicenseDetails = ({ setModelDrawer, personDetails, onFinish }) => {
  const Text = Typography;
  return (
    <Text style={{ display: "flex", alignItems: "center" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Tooltip title={"Client Name"} placement="left">
          <BiEditAlt className={styles.textAlignment} style={{fontSize: "25px"}} />
        </Tooltip>
      </div>
      <div>
        <div style={{marginLeft: "5px", width: "100%"}}>
            {
                personDetails?.licenseData?.map((license) => {
                    return <div style={{ width: "90%", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", fontSize: "18px" }}>
                        { license?.id } - { license.label }
                    </div>
                })
            }
        </div>
      </div>
    </Text>
  );
};

export { LicenseDetails };
